import { config, useSpring } from '@react-spring/web';

import { useEffectOnChange } from '@sorare/core/src/hooks/state/useEffectOnChange.ts';

import type { CardRevealUIState } from '#src/components/essence/CardPullExperience/CardsReveal/types.ts';

const idleState = {
  opacity: 1,
  scale: 1,
};

const pulledState = {
  opacity: 0,
  scale: 1.2,
};

export const useUIStyles = (uiState: CardRevealUIState) => {
  const [uiStyles, api] = useSpring(() => ({
    from: uiState === 'idle' ? idleState : pulledState,
  }));

  const startAnimation = () => {
    if (uiState === 'idle') {
      api.start({
        to: idleState,
        immediate: true,
      });
    } else if (uiState === 'pulling') {
      api.start({
        to: pulledState,
        config: config.slow,
      });
    }
  };

  useEffectOnChange(uiState, () => {
    startAnimation();
  });

  return uiStyles;
};
